module.exports = __webpack_public_path__ + "assets/icons/favicon-loki-auction-e35e.ico";